<div class="main">
  <!-- <app-plays-map></app-plays-map> -->

  <div *ngIf="isLoading" class="loading-container">
    <p>Loading location data...</p>
    <!-- You could add a spinner component here -->
  </div>

  <div *ngIf="!isLoading && hasFullAnalyticsAccess">
    <div class="view-toggle-container">
      <mat-button-toggle-group
        [(ngModel)]="currentView"
        aria-label="Location Data Type"
      >
        <mat-button-toggle value="streams">Streams</mat-button-toggle>
        <mat-button-toggle value="videos">Video Views</mat-button-toggle>
      </mat-button-toggle-group>
    </div>

    <div class="inner">
      <!-- Streams View -->
      <div *ngIf="currentView === 'streams'">
        <div *ngIf="(countryData | keyvalue)?.length > 0; else noStreamData">
          <section class="statList" style="padding-bottom: 2rem">
            <h1>Streams By Country</h1>
            <div class="titling-row">
              <span class="title-empty-space"></span>
              <span class="title-play-count">Plays</span>
              <span class="title-unique-listeners">Listeners</span>
            </div>

            <hr />
            <ul class="track-list">
              <li
                *ngFor="let item of countryData | keyvalue"
                class="track-item"
              >
                <span class="track-name">{{ item.key }}</span>
                <span class="play-count">{{ item.value.playCount }}</span>
                <span class="unique-listeners">{{
                  item.value.uniqueUserCount
                }}</span>
              </li>
            </ul>
          </section>

          <div class="horiLine"></div>
          <section class="statList">
            <h1>Streams by City</h1>
            <div class="titling-row">
              <span class="title-empty-space"></span>
              <span class="title-play-count">Plays</span>
              <span class="title-unique-listeners">Listeners</span>
            </div>

            <hr />
            <ul class="track-list">
              <li *ngFor="let item of cityData | keyvalue" class="track-item">
                <span class="track-name">{{ item.key }}</span>
                <span class="play-count">{{ item.value.playCount }}</span>
                <span class="unique-listeners">{{
                  item.value.uniqueUserCount
                }}</span>
              </li>
            </ul>
          </section>
        </div>
        <ng-template #noStreamData>
          <p class="no-data-message">No stream location data available.</p>
        </ng-template>
      </div>

      <!-- Videos View -->
      <div *ngIf="currentView === 'videos'">
        <div
          *ngIf="(videoCountryData | keyvalue)?.length > 0; else noVideoData"
        >
          <section class="statList" style="padding-bottom: 2rem">
            <h1>Video Views By Country</h1>
            <div class="titling-row">
              <span class="title-empty-space"></span>
              <span class="title-play-count">Views</span>
              <span class="title-unique-listeners">Viewers</span>
            </div>

            <hr />
            <ul class="track-list">
              <li
                *ngFor="let item of videoCountryData | keyvalue"
                class="track-item"
              >
                <span class="track-name">{{ item.key }}</span>
                <span class="play-count">{{ item.value.viewCount }}</span>
                <span class="unique-listeners">{{
                  item.value.uniqueUserCount
                }}</span>
              </li>
            </ul>
          </section>
          <section class="statList">
            <h1>Video Views by City</h1>
            <div class="titling-row">
              <span class="title-empty-space"></span>
              <span class="title-play-count">Views</span>
              <span class="title-unique-listeners">Viewers</span>
            </div>

            <hr />
            <ul class="track-list">
              <li
                *ngFor="let item of videoCityData | keyvalue"
                class="track-item"
              >
                <span class="track-name">{{ item.key }}</span>
                <span class="play-count">{{ item.value.viewCount }}</span>
                <span class="unique-listeners">{{
                  item.value.uniqueUserCount
                }}</span>
              </li>
            </ul>
          </section>
        </div>
        <ng-template #noVideoData>
          <p class="no-data-message">No video location data available.</p>
        </ng-template>
      </div>
    </div>
  </div>

  <div
    *ngIf="!isLoading && !hasFullAnalyticsAccess"
    class="upgrade-prompt-full-page"
  >
    <h2>Unlock Detailed Location Analytics</h2>
    <p>See where your fans are listening from, down to the city level.</p>
    <p>This feature is available for Verified, Premium, and Label accounts.</p>
    <button (click)="navigateToUpgrade()">Upgrade to Verified</button>
  </div>
</div>
